function isLongEnough(password: string) {
  return password.length >= 12;
}

function hasNumberOrSpecialChar(password: string) {
  return /[0-9]/.test(password) || /[^A-Za-z0-9]/.test(password);
}

function hasUpperCaseChar(password: string) {
  return /[A-Z]/.test(password);
}

function haveMatchingPasswords(password: string, passwordConfirmation: string) {
  return password === passwordConfirmation;
}

export {
  isLongEnough,
  hasNumberOrSpecialChar,
  hasUpperCaseChar,
  haveMatchingPasswords,
};
